  import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
  import api from "../pages/chat/api";
  import Cookies from "js-cookie";
  import { getFreshAccessToken } from "../pages/chat/api";
let activeChatSocket = null;
let shouldStopStreaming = false;
  export const fetchChatStream = createAsyncThunk(
    "chat/fetchChatStream",
    async ({ folderId, query , file_keys, folder_name}, { rejectWithValue, dispatch }) => {
      shouldStopStreaming = false;
      let token = await getFreshAccessToken();

      if (!token) {
        return rejectWithValue("No authorization token found");
      }

    const wsUrl = `wss://stagingbackend.docusensa.com/ws/chat-with-folder/${folderId}/?token=${token}`;
shouldStopStreaming = false;
if (activeChatSocket && activeChatSocket.readyState !== WebSocket.CLOSED) {
  activeChatSocket.close();
}
      const socket = new WebSocket(wsUrl);
activeChatSocket = socket;
      return new Promise((resolve, reject) => {
        let accumulatedAnswer = "";
        let botMessageId = null;
        let runId = null;
        let generatedQuestions = null;

        // Define types/messages to ignore
        const ignoredTypes = ["info", "status"];
        const ignoredMessages = [
          "Streaming has started.",
          "WebSocket connected",
          "Streaming complete.",
        ];

        socket.onopen = () => {
          socket.send(JSON.stringify({  query,
            file_keys,
            folder_name, }));
             dispatch(updateStatus("loading"));
          dispatch(updatePartialAnswer(""));
        };

        socket.onmessage = (event) => {
            if (shouldStopStreaming) {
            console.warn("🛑 shouldStopStreaming is true → Closing WebSocket...");
            socket.close();
            dispatch(updateStatus("stopped")); // Optional UI update
            return;
          }
          
          try {
            const data = JSON.parse(event.data);

            // Skip messages based on type
            if (ignoredTypes.includes(data.type)) {
              return;
            }

            // Skip specific messages
            if (data.message && ignoredMessages.some((msg) => data.message.includes(msg))) {
              return;
            }

            if (
              data.type !== "info" &&
              data.status !== "connected" &&
              data.message
            ) {
              accumulatedAnswer += data.message;
              dispatch(updatePartialAnswer(accumulatedAnswer));
            }

            if (data.type === "final") {
              botMessageId = data.data.bot_message_id;
              runId = data.data.run_id;
              generatedQuestions = data.data.generated_questions;

              dispatch(updateFinalAnswer(accumulatedAnswer));
              dispatch(updateBotMessageInfo({ botMessageId, runId, generatedQuestions }));
              dispatch(updateStatus("succeeded"));
              socket.close();
              resolve(accumulatedAnswer);
            }

            if (data.type === "completed") {
            }
          } catch (error) {
            console.error("Error parsing WebSocket message:", event.data, error);
          }
        };

        socket.onerror = (error) => {
          console.error("WebSocket error:", error);
          reject(rejectWithValue("WebSocket connection error"));
        };

        socket.onclose = () => {
        };
      });
    }
  );




  const chatSlice = createSlice({
    name: "chat",
    initialState: {
      messages: [],
      partialAnswer: '',
      finalAnswer: '',
      status: 'idle',
      error: null,
      botMessageId: null, 
      runId: null,
      generatedQuestions: null,
    },
    reducers: {
      resetChatState: (state) => {
        state.messages = [];
        state.partialAnswer = '';
        state.finalAnswer = '';
        state.status = 'idle';
        state.error = null;
        state.botMessageId = null;
        state.runId = null; 
        state.generatedQuestions = null;
      },
      updatePartialAnswer: (state, action) => {
        state.partialAnswer = action.payload;
      },
      updateStatus: (state, action) => {
      state.status = action.payload;
    },
      updateFinalAnswer: (state, action) => {
        state.finalAnswer = action.payload;
      },
      updateBotMessageInfo: (state, action) => {
        const { botMessageId, runId, generatedQuestions } = action.payload;
        state.botMessageId = botMessageId;
        state.runId = runId;
        state.generatedQuestions = generatedQuestions;
      },
      resetStopStreaming: (state) => {
          shouldStopStreaming = false;
        },
        stopStreaming: (state) => {
        shouldStopStreaming = true;
      }
    },
    extraReducers: (builder) => {
      builder
        .addCase(fetchChatStream.pending, (state) => {
          state.status = "loading";
        })
        .addCase(fetchChatStream.fulfilled, (state, action) => {
          state.messages.push(action.payload);
          state.status = 'succeeded';
        })
        .addCase(fetchChatStream.rejected, (state, action) => {
          state.error = action.payload;
          state.status = 'failed';
        });
    },
  });

  export const {  updatePartialAnswer, updateFinalAnswer, updateBotMessageInfo, resetChatState ,updateStatus, stopStreaming,
  resetStopStreaming,} =
    chatSlice.actions;

  export default chatSlice.reducer;
